<template>
  <div id="general-page" class="analytic">
    <page-header-component v-if="topics" :topics="topics" :hideValidate="false" icon="bi bi-bar-chart-steps"
      title="Analisis Umum" />
    <div class="row mb-1" v-if="display_tipe == 3">
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-gap">
        <!-- START WIDGET D3 widget_graphWidget-->
        <div class="widget-12 card card-default widget-loader-circle shade">
          <div class="card-body">
            <ul class="nav nav-tabs nav-tabs-simple d-md-flex d-lg-flex d-xl-flex" role="tablist"
              data-init-reponsive-tabs="dropdownfx">
              <li class="nav-item" @click="switchTab(tab_medkon)" v-if="display_tipe == 2 || display_tipe == 3">
                <a class="active" data-toggle="tab" role="tab" data-target="#tab2hellowWorld" href="#"
                  aria-selected="true" style="font-size: 1rem;">
                  <i class="bi bi-globe-americas" /> Media Online
                </a>
              </li>
              <li class="nav-item" @click="switchTab(tab_medsos)" v-if="display_tipe == 1 || display_tipe == 3">
                <a href="#" data-toggle="tab" role="tab" data-target="#tab2FollowUs" class="" aria-selected="false" style="font-size: 1rem;">
                  <i class="bi bi-heart-fill text-danger" /> Media Sosial
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <div>
        <component v-if="topics" :is="currentTab" class="tab" />
      </div>
    </div>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import tab_medkon from "@/views/components/analytics/general/tab_medkon.vue";
import tab_medsos from "@/views/components/analytics/general/tab_medsos.vue";

export default {
  name: "General",
  title: "Analitik Umum | Sibernetik",
  components: {
    "page-header-component": page_header,
  },
  data() {
    return {
      tab_medkon: tab_medkon,
      tab_medsos: tab_medsos,
      currentTab:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
          this.$store.getters.user.project.project_detail.display_tipe == 3
          ? tab_medkon
          : tab_medsos,
      topics: null,
      id_project: this.$store.getters.user.id_project,
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
    };
  },
  methods: {
    switchTab: function (component) {
      this.currentTab = component;
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.topics = response.data;
        } else {
          this.topics = {};
        }
      });
    },
  },
  created: function () {
    this.getTopic();
  },
};
</script>

<style>
.overlay-button {
  position: fixed;
  bottom: 45px;
  right: 30px;
  z-index: 9;
}

.overlay-button button {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  font-size: 30px;
  font-weight: bolder;
}

.nav-tabs-simple>li>a:after {
  /* background-color: #0f8ff9 !important; */
  background-color: #ed7a0f !important;
}

.nav-tabs-simple>li>a {
  font-size: 12px;
}
</style>
